import { Image, Link, StyleSheet, Text, View } from "@react-pdf/renderer";
import { extractUploadFileName, GOAL_TRACK_PARAMETERS, GOAL_TRACK_PARAMETERS_COLORS_V2, GOAL_TRACK_PARAMETERS_V2 } from "config/constants";
import { globalStyles } from "config/pdfStyles";
import { getGoalTrackingCount, getGoalTrackingPercentage } from "helpers/assessment";
import attachments_img from "Assets/images/AttachmentIcon.png"
import Html from "react-pdf-html";
import attachment_img from "Assets/images/attachment_img.png"
import PDFHtmlRenderer from "./PDFHtmlRenderer";

const GoalReviewSection = ({ assessmentGoals, therapistDetails, showChart = false, chartImages = [], styles }) => {
  return (
    <>
      {assessmentGoals?.length > 0 && assessmentGoals?.map((goal, index) => {
        const attachments = goal?.goal_attachementData ? JSON.parse(goal?.goal_attachementData) : [];
        const showTracker = goal?.show_tracker === "show";
        return (
          <View style={{ marginBottom: "20px" }} wrap={false}>
            <View style={{ borderBottom: "0.75px solid #000", paddingBottom: "2px", marginBottom: "4px" }}>
              <Text style={{ ...styles.mainSubHeading }}>{index + 1}. GOAL</Text>
            </View>
            <View style={{ ...styles.flex, gap: "12px" }}>

              <View style={{ width: "40%", gap: "4px" }}>
                <View style={{ ...styles.flex, }}>
                  <Text style={{ ...styles.subHeading, width: "25%" }}>AREA</Text>
                  <Text style={{ ...styles.para, width: "75%" }}>{goal?.assesmentGoalDisciplineArea?.name}</Text>
                </View>
                <View style={{ ...styles.flex }}>
                  <Text style={{ ...styles.subHeading, width: "25%" }}>GOAL</Text>
                  <Text style={{ ...styles.para, width: "75%" }}>{goal?.assesmentGoalDetail?.title}</Text>
                </View>
                <View style={{ ...styles.flex }}>
                  <Text style={{ ...styles.subHeading, width: "25%" }}>CONTEXT</Text>
                  <Text style={{ ...styles.para, width: "75%" }}>{goal?.assesmentGoalContext?.context}</Text>
                </View>
                <View style={{ ...styles.flex }}>
                  <Text style={{ ...styles.subHeading, width: "25%" }}>DETAIL</Text>
                  <Text style={{ ...styles.para, width: "75%", lineHeight: "13px" }}>{goal?.goal_description}</Text>
                </View>
                {showTracker && (
                  <View style={{ marginTop: "6px" }}>
                    <View style={{ borderBottom: "0.75px solid #000", paddingBottom: "2px", marginBottom: "4px" }}>
                      <Text style={{ ...styles.mainSubHeading }}>session outcomes</Text>
                    </View>
                    <View style={{ marginTop: "3px", ...styles.flex, gap: "12px" }}>
                      <View style={{ width: "40%" }}>
                        {chartImages[index] && (
                          <Image
                            src={chartImages[index]}
                          />
                        )}
                      </View>
                      {goal?.goalTracking?.length > 0 ? (
                        <View style={{ width: "60%", gap: "4px" }}>
                          {Object.entries(GOAL_TRACK_PARAMETERS_V2)?.map(([param, label], index) => {
                            let parameterPercentage =
                              getGoalTrackingPercentage(
                                param,
                                goal?.goalTracking
                              );
                            let counts = getGoalTrackingCount(param, goal?.goalTracking);
                            const color = GOAL_TRACK_PARAMETERS_COLORS_V2[param];
                            return (
                              <View style={{ ...styles.flex, justifyContent: "space-between" }}>
                                <View style={{ ...styles.flex, gap: "4px" }}>
                                  <Text style={{ width: "9px", height: "9px", backgroundColor: color }}></Text>
                                  <Text style={{ ...styles.mainSubHeading }}>{param}</Text>
                                  <Text style={{ ...styles.para }}>{label} ({counts.occurrence}/{counts.total})</Text>
                                </View>
                                <Text style={{ ...styles.para }}> {parameterPercentage}%</Text>
                              </View>
                            );
                          })}
                        </View>
                      ) : (
                        <Text style={{ ...styles.para }}>
                          Goal not tracked yet
                        </Text>
                      )}
                    </View>
                  </View>
                )}
              </View>
              <View style={{ width: "60%" }}>
                <View style={{ borderBottom: "0.75px solid #000", paddingBottom: "2px", marginBottom: 0 }}>
                  <Text style={{ ...styles.mainSubHeading }}>GOAL PROGRESSION</Text>
                </View>
                <View style={{ marginTop: 5 }}>
                  <PDFHtmlRenderer
                    style={{ fontSize: 8, ...styles.para }}
                    data={goal?.goal_notes}
                  />
                </View>
                {attachments?.length && (
                  <View>
                    <View>
                      <Text style={styles.subHeading}>ATTACHMENTS</Text>
                    </View>
                    {attachments?.map((item, index) => (
                      <View style={{ marginTop: '7px', ...styles.flex, gap: "3px" }}>
                        <Text style={{ ...styles.link, borderBottom: 0 }} >
                          {index + 1}.
                        </Text>
                        <Link
                          key={index}
                          src={item?.attachment_name}
                          style={{ ...styles.link, marginLeft: 2 }}
                        >
                          {extractUploadFileName(item?.attachment_name)}
                        </Link>
                        <Image style={{ width: 6 }} src={attachment_img} alt="attachment_img" />
                        {/* <Text><Image src={attachments_img} style={{ width: 5, height: 5 }} /></Text> */}
                      </View>
                    ))}
                  </View>
                )}
              </View>
            </View>
          </View>
        )
      })}
    </>
  )
}


export default GoalReviewSection;